const FILTERS_DESKTOP_HEADER = ".find-company-filters-header",
	FILTERS_DESKTOP_TOOGLE = ".find-company-filters-toggle",
	FILTERS_DESKTOP_BODY = ".find-company-filters-body-container",
	FILTERS_DESKTOP_FORM_ID = "#find-company",
	STICKY_MAP = ".find-company-results-map",
	MAP_CONTAINER = ".find-company-map-container",
	RESULTS_CONTAINER = ".find-company-results-container",
	STICKY_HEADER = "header",
	SHOW_MAP = ".showMap",
	SHOW_SERVICES = ".showServices",
	COMPANY_SERVICES = ".find-company-services",
	CONTACT_COMPANY_BUTTON = ".find-company-contact-company-button",
	CONTACT_COMPANY_FORM = ".find-company-contact-company-form-container",
	CONTACT_COMPANY_FORM_TEMPLATE = ".find-company-contact-company-form-container.template",
	CONTACT_FORM_DYNAMIC_VALUES_NAME = "gform_field_values",
	CONTACT_FORM_HIDDEN_EMAIL = '[name="input_6"]',
	CONTACT_FORM_HIDDEN_SID = '[name="input_7"]',
	CONTACT_COMPANY_NAME = ".company-name",
	ZIP_INPUT = ".zip-input",
	FILTERS_SELECTED = ".find-company-filters-selected",
	FILTERS_MOBILE_TOGGLER = ".find-company-filters-mobile-toggler",
	FILTERS_MOBILE_MODAL = ".find-company-filters-mobile-modal",
	FILTERS_MOBILE_FILTER_TOGGLER = ".find-company-filters-mobile-modal-filter-title",
	FILTERS_MOBILE_FILTER_BODY = ".find-company-filters-mobile-modal-filter-body",
	FILTERS_MOBILE_FILTER = ".find-company-filters-mobile-modal-filter",
	FILTERS_MOBILE_FILTER_COUNTER = ".find-company-filters-mobile-modal-counter",
	FILTER_MOBILE_FILTER_CLEAR = ".find-company-filters-mobile-modal-button-clear",
	FILTER_MOBILE_FILTER_FORM = ".find-company-filters-mobile-modal-form",
	MAIN = "main",
	BODY = "body",
	SUBMIT_DELAY = 1000,
	DEFAULT_RADIUS = 20,
	DEFAULT_RADIUS_KM = 20;

function isMobile() {
	return !window.matchMedia("(min-width: 80em)").matches;
}
/**
 * Helper funcion checks if the map should be sticky and set it as sticky.
 * @param {*} $map
 * @param {*} $results_container
 * @param {*} mapStickyOn
 */
function sticky($map_container, $map, $results_container) {
	const is_scrolling_up = jQuery("body.scroll-up").length > 0;
	const mapStickyOn = $results_container.offset().top - (is_scrolling_up ? jQuery(STICKY_HEADER).outerHeight() : 27); //27 = Top margin
	const mapStickyOff =
		$results_container.offset().top + $results_container.outerHeight() - $map_container.outerHeight() - 27; //27= article bottom margin.
	$map.toggleClass("sticky", !isMobile() && window.pageYOffset > mapStickyOn && window.pageYOffset < mapStickyOff);
	$map.toggleClass("sticky-bottom", !isMobile() && window.pageYOffset > mapStickyOff);
}
/**
 * Initializes the sticky map funcionalty
 */
function initStickyMap() {
	jQuery("html, body").css("-webkit-overflow-scrolling", "auto");

	const $map = jQuery(STICKY_MAP);
	const $results_container = jQuery(RESULTS_CONTAINER);
	const $map_container = jQuery(MAP_CONTAINER);

	if ($results_container.length) {
		$map.css("max-width", $map.parent().outerWidth());
		jQuery(window).on("scroll resize touchstart touchmove touchend", () => {
			sticky($map_container, $map, $results_container);
		});
		jQuery(window).on("resize", function () {
			$map.css("max-width", $map.parent().outerWidth());
			$map_container.css("height", $map_container.outerWidth()); //keep the map square
		});
		$map_container.css("height", $map_container.outerWidth()); //init the map square
		setTimeout(() => {
			sticky($map_container, $map, $results_container);
		}, 200);
	}
}

/**
 * Initializes the Google map with markers defined on the backend and set it into window.findCompaniesMarkers on page building.
 */
function initMap() {
	/**
	 * window.findCompaniesMarkers is defined on definition6-companies/includes/findPartnerCompany.php
	 */
	/*global google*/
	if (typeof window.findCompaniesMarkers !== "undefined" && window.findCompaniesMarkers.length) {
		var map = new google.maps.Map(document.getElementById("companiesMap"), {
			center: new google.maps.LatLng(
				parseFloat(window.findCompaniesMarkers[0]["lat"]),
				parseFloat(window.findCompaniesMarkers[0]["lng"]),
			),
			zoom: 11,
			styles: typeof window.findContractorsMapStyles !== "undefined" ? window.findContractorsMapStyles : {},
		});

		var bounds = new google.maps.LatLngBounds();
		for (let index = 0; index < window.findCompaniesMarkers.length; index++) {
			let marker = window.findCompaniesMarkers[index];
			var id = marker["id"];
			var point = new google.maps.LatLng(parseFloat(marker["lat"]), parseFloat(marker["lng"]));
			var icon = {
				path: google.maps.SymbolPath.CIRCLE,
				fillColor: "#005778",
				fillOpacity: 1,
				strokeWeight: 0,
				scale: 10,
				size: new google.maps.Size(34, 34),
			};
			marker = new google.maps.Marker({
				map: map,
				position: point,
				url: "#company_" + id.toString(),
				label: {
					text: id.toString(),
					color: "white",
					fontSize: "14px",
				},
				icon: icon,
			});
			//Add event listener on marker click to scroll to company's article.
			google.maps.event.addListener(marker, "click", function () {
				const elem = jQuery(jQuery(this).attr("url"));
				const scroll_top = Math.max(jQuery("html").scrollTop(), jQuery("body").scrollTop());
				const head = scroll_top < elem.offset().top ? 27 : jQuery(STICKY_HEADER).outerHeight(); // 27 = Map Margin Top
				jQuery("html, body").scrollTop(elem.offset().top - head);
			});
			bounds.extend(point);
		}

		if (window.findCompaniesMarkers.length > 1) {
			map.fitBounds(bounds);
		}
	}
	//Set sticky on load if needed.
	initStickyMap();
}

function initFilter() {
	let timer;
	let $filters_form = jQuery(FILTERS_DESKTOP_FORM_ID);

	//Set the 1 sec delayed submit on filters change.
	$filters_form.find("input").on("change", () => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			$filters_form.submit();
		}, SUBMIT_DELAY);
	});

	//Filters toggle visibility
	jQuery(FILTERS_DESKTOP_TOOGLE).on("click", () => {
		jQuery(FILTERS_DESKTOP_HEADER).toggleClass("open");
		jQuery(FILTERS_DESKTOP_BODY).slideToggle(300, "swing");
	});

	// open up filters if search already submitted
	// if (window.location.href.indexOf("?") !== -1) {
	// 	jQuery(FILTERS_DESKTOP_HEADER).toggleClass("open");
	// 	jQuery(FILTERS_DESKTOP_BODY).slideToggle(300, "swing");
	// }

	//Submit filters on Zip key press = Enter.
	jQuery(ZIP_INPUT).on("keypress", (e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			jQuery(FILTERS_DESKTOP_FORM_ID).submit();
		}
	});
	//Remove filters buttons click bind.
	jQuery(FILTERS_SELECTED).on("click", function (e) {
		e.preventDefault();
		let $selected_clear = jQuery(this);
		let defaultRadius;
		if ($selected_clear.data("name") == "radius") {
			if ($selected_clear.data("unit") == "km") {
				defaultRadius = DEFAULT_RADIUS_KM;
			} else {
				defaultRadius = DEFAULT_RADIUS;
			}
			jQuery(FILTERS_DESKTOP_BODY)
				.find('input[name = "radius"][value = "' + defaultRadius + '"]')
				.prop("checked", true)
				.change();
		} else {
			jQuery(FILTERS_DESKTOP_BODY)
				.find('input[name = "' + $selected_clear.data("name") + '"][value = "' + $selected_clear.data("value") + '"]')
				.prop("checked", false)
				.change();
		}
		$selected_clear.remove();
	});

	//Click bind to toogle mobile filters modal menu visibility
	jQuery(FILTERS_MOBILE_TOGGLER).on("click", (e) => {
		e.preventDefault();
		jQuery(FILTERS_MOBILE_MODAL).toggleClass("open");
		let isOpen = jQuery(FILTERS_MOBILE_MODAL).hasClass("open");
		jQuery(MAIN).css("z-index", isOpen ? 10000 : 1);
		jQuery(BODY).css("overflow", isOpen ? "hidden" : "auto");
	});

	//Click bind to toggle mobile filters dropdown visibility
	jQuery(FILTERS_MOBILE_FILTER_TOGGLER).on("click", function (e) {
		e.preventDefault();
		let $toggler = jQuery(this);
		if (!$toggler.hasClass("open")) {
			$toggler.closest(FILTERS_MOBILE_MODAL).find(FILTERS_MOBILE_FILTER_TOGGLER).removeClass("open");
			$toggler
				.closest(FILTERS_MOBILE_MODAL)
				.find(FILTERS_MOBILE_FILTER_BODY + ":visible")
				.slideUp(300, "swing");
			$toggler.addClass("open");
		} else {
			$toggler.removeClass("open");
		}
		$toggler.parent().find(FILTERS_MOBILE_FILTER_BODY).slideToggle(300, "swing");
	});
	//Update filter count values on inputs change. When radius == DEFAULT_RADIUS it does not count as applied filter.
	jQuery(FILTERS_MOBILE_FILTER)
		.find("input")
		.on("change", function () {
			let filters_counter = jQuery(FILTERS_MOBILE_FILTER).find('input[name="services[]"]:checked').length;
			if (filters_counter > 0) {
				jQuery(FILTERS_MOBILE_FILTER_COUNTER).text("(" + filters_counter + ")");
				jQuery(FILTER_MOBILE_FILTER_CLEAR).attr("disabled", false);
			} else {
				jQuery(FILTERS_MOBILE_FILTER_COUNTER).text("");
				jQuery(FILTER_MOBILE_FILTER_CLEAR).attr("disabled", true);
			}
		});
	//Bind click for the Mobile Filter Clear button
	jQuery(FILTER_MOBILE_FILTER_CLEAR).on("click", (e) => {
		e.preventDefault();
		jQuery(FILTERS_MOBILE_FILTER).find('input[name="services[]"]:checked').prop("checked", false); //reset services
		jQuery(FILTERS_MOBILE_FILTER)
			.find('input[name="radius"][value = "' + DEFAULT_RADIUS + '"]')
			.prop("checked", true); //set radius to default value
		//Reset clear button
		jQuery(FILTERS_MOBILE_FILTER_COUNTER).text("");
		jQuery(FILTER_MOBILE_FILTER_CLEAR).attr("disabled", true);
		//Submits form
		jQuery(FILTER_MOBILE_FILTER_FORM).submit();
	});
}

/**
 * Initializes the Show Services/Map check bar funcionality.
 */
function initCheckBar() {
	//Toggles initial Services visbility
	jQuery(COMPANY_SERVICES).toggle(jQuery(SHOW_SERVICES).is(":checked"));

	//Toggles initial map visibilty
	let showMap = jQuery(SHOW_MAP).is(":checked");
	jQuery(RESULTS_CONTAINER).toggleClass("expanded", !showMap);

	//Bind for Show Service check click on desktop and mobile to toogle Services lists visibilty
	jQuery(SHOW_SERVICES).on("click", function () {
		let checked = jQuery(this).is(":checked");
		jQuery(SHOW_SERVICES).attr("checked", checked);
		jQuery(COMPANY_SERVICES).slideToggle(300, "swing");
		jQuery(FILTERS_DESKTOP_FORM_ID)
			.find('input[name="showServices"]')
			.attr("value", checked ? 1 : 0); //Set hidden field to carry selection over form submition
	});

	//Bind for Show Map check click on desktop and mobile to toogle Map's visibilty
	jQuery(SHOW_MAP).on("click", function () {
		let checked = jQuery(this).is(":checked");
		jQuery(SHOW_MAP).attr("checked", checked);
		jQuery(RESULTS_CONTAINER).toggleClass("expanded", !checked);
		jQuery(FILTERS_DESKTOP_FORM_ID)
			.find('input[name="showMap"]')
			.attr("value", checked ? 1 : 0); //Set hidden field to carry selection over form submition
	});
}

/** GRAVITY Forms Styles Helpers Begin */

function focusout(e) {
	Array.from(e.target.closest("form").querySelectorAll(".labels-inside input, .labels-inside textarea")).forEach(
		(_inp) => {
			if (_inp.value.replace("(___) ___-____", "").trim() == "") {
				_inp.closest("span, .labels-inside").classList.remove("input-focus");
			} else {
				_inp.closest("span, .labels-inside").classList.add("input-focus");
			}
		},
	);
}

function focusin(e) {
	e.target.closest("span, .labels-inside").classList.add("input-focus");
}

function initGForm() {
	let inputs = document.querySelectorAll(
		CONTACT_COMPANY_FORM +
			":not(.template) .labels-inside input, " +
			CONTACT_COMPANY_FORM +
			":not(.template)  .labels-inside textarea, " +
			CONTACT_COMPANY_FORM +
			":not(.template)  .labels-inside select",
	);
	Array.from(inputs).forEach((input) => {
		//set initial state
		if (input.value.replace("(___) ___-____", "").trim() == "") {
			input.closest("span, .labels-inside").classList.remove("input-focus");
		} else {
			input.closest("span, .labels-inside").classList.add("input-focus");
		}
		//bind focusin
		if (!input.hasAttribute("gf_focus")) {
			//if focusin/out bind wasn't set, set it.
			input.addEventListener("focusin", focusin);
			//bind change/blur
			input.addEventListener("change", focusout);
			input.addEventListener("blur", focusout);
			input.setAttribute("gf_focus", true);
		}
	});
}

function handleContactFormSuccess() {
	jQuery(CONTACT_COMPANY_FORM + " .hide-onsuccess").hide();
}

/** GRAVITY Forms Styles Helpers END */

/**
 * Initializes the Contact Contract/Dealer buttons click bind and set title and hidden contact email on gravity form.
 */
function initContactCompany() {
	jQuery(CONTACT_COMPANY_BUTTON).on("click", function () {
		let $button = jQuery(this);
		if (!$button.hasClass("open")) {
			$button.addClass("open");

			//Clone the Contact Form from a hidden template and set title and hidden fields with contact mail.
			let $contact_form = jQuery(CONTACT_COMPANY_FORM_TEMPLATE).clone();
			$contact_form.removeClass("template"); //so we don't reclone the clones.
			$contact_form.find(CONTACT_COMPANY_NAME).text($button.data("name"));
			$contact_form
				.find('[name = "' + CONTACT_FORM_DYNAMIC_VALUES_NAME + '"]')
				.val("contact_email=" + $button.data("email"));
			$contact_form.find(CONTACT_FORM_HIDDEN_EMAIL).val($button.data("email")); //company's contact email
			$contact_form.find(CONTACT_FORM_HIDDEN_SID).val($button.data("sid")); //salesforce id
			$contact_form.find(".labels-inside input, .labels-inside textarea").removeAttr("gf_focus"); //reset focus bind attr
			$contact_form.hide(); //hide before slide down.
			$button.after($contact_form);
			$contact_form.slideDown(300, "swing");
			initGForm();
		} else {
			//close and remove cloned form.
			$button.removeClass("open");
			$button
				.parent()
				.find(CONTACT_COMPANY_FORM)
				.slideUp(300, "swing", function () {
					jQuery(this).remove();
				});
		}
	});
}

// Mobile viewport real height(minus bottom toolbar) To use on CSS
function setRealViewportHeightCustomAttritbute() {
	// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
	let vh = window.innerHeight * 0.01;
	// Then we set the value in the --vh custom property to the root of the document
	document.documentElement.style.setProperty("--vh", `${vh}px`);
}

function runMapWhenReady(count = 0) {
	if (typeof google !== "undefined" && typeof google.maps !== "undefined") {
		//Initializes Google Map
		initMap();
		//Initializes Filters
		initFilter();
		//Initializes the Show Services/Map Checks Bar.
		initCheckBar();
		//Initializes Contact Contactr/Dealer button
		initContactCompany();
		//Initializes Gravity Form Helper functions
		initGForm();
		//set viewport height minus the floating bottom bar, used on findpartnercompany.scss
		setRealViewportHeightCustomAttritbute();

		jQuery(document).on("gform_post_render", initGForm); //reinit form after invalid submission
		jQuery(document).on("gform_confirmation_loaded", handleContactFormSuccess);
		jQuery(window).on("resize", setRealViewportHeightCustomAttritbute);
	} else if (count < 5) {
		setTimeout(() => {
			runMapWhenReady(count + 1);
		}, 750); // try again in 750 milliseconds
	}
}

jQuery(document).ready(runMapWhenReady());
